import dayjs from "dayjs";
import { taskService } from "../../services";

type MappingProps = {
    body?: string;
    id?: string;
    actioner: string;
};

const mapEmailBody = async ({ body, id, actioner }: MappingProps): Promise<string> => {

    let currentTask: any = {};
    if (id) {
        currentTask = await taskService.fullTask(id);
    }

    if (!body) {
        return "";
    }

    const replacements: Record<string, string | boolean> = {
        "{TaskName}": currentTask.name ?? "",
        "{TaskType}": currentTask.taskTypeName ?? "",
        "{TaskURL}": currentTask.taskURL ?? "",
        "{PersonnelList}": currentTask.userName ?? "",
        "{Actioner}": actioner,
        "{CreationDate}": currentTask.creationDate ?? "",
        "{CompletionDate}": currentTask.completedDate ?? "",
        "{DeletionDate}": dayjs(new Date()).format("ddd DD MMM YYYY - HH:mm").toString(),
        "{DueDate}": currentTask.dueDate ?? "",
        "{Location}": currentTask.location ?? "",
        "{RecursiveInfoIfRecursive}": currentTask.recursiveInterval ? `Recurring on ${currentTask.days} every ${currentTask.recursiveInterval} weeks` : "Not Recursive",
    };

    return body.replace(/{TaskName}|{TaskType}|{TaskURL}|{PersonnelList}|{Actioner}|{CreationDate}|{CompletionDate}|{DeletionDate}|{DueDate}|{Location}|{RecursiveInfoIfRecursive}/g, (match: any) => String(replacements[match] ?? match));
};
export default mapEmailBody;
